var _path, _circle, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocations = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 6.86765C15.25 7.343 15.0705 7.96665 14.7145 8.70684C14.3645 9.43476 13.8738 10.2145 13.3218 10.9849C12.2182 12.5251 10.9157 13.9645 10.1391 14.7829C10.0596 14.8667 9.94042 14.8667 9.86088 14.7829C9.08426 13.9645 7.78175 12.5251 6.6782 10.9849C6.12623 10.2145 5.63552 9.43476 5.28545 8.70684C4.92949 7.96665 4.75 7.343 4.75 6.86765C4.75 4.05693 7.08465 1.75 10 1.75C12.9154 1.75 15.25 4.05693 15.25 6.86765Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 7,
    r: 1.34961,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14819 13.75H6.66434L5.53589 12.25H3.81971C3.3631 12.25 2.95883 12.5451 2.81967 12.98L1.32816 17.6409C1.15265 18.1894 1.56185 18.75 2.13772 18.75H10.0007V17.25H3.02819L4.14819 13.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H17.863C17.9308 18 17.9789 17.934 17.9582 17.8695L16.4667 13.2086C16.427 13.0843 16.3115 13 16.181 13H12",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocations);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/locations.8825f8517f1a0cbec8442e08fef18412.svg";